import { useState } from 'react';
import FormInput, { FormInputProps } from './FormInput';

const PasswordInput = <TFormValues extends Record<string, any>>({
  ...props
}: FormInputProps<TFormValues>): JSX.Element => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <FormInput
      {...props}
      type={showPassword ? 'text' : 'password'}
      suffixIconName={showPassword ? 'slashedEye' : 'openEye'}
      onIconClick={handleTogglePassword}
    />
  );
};

export default PasswordInput;
